import {reduxForm, Field, getFormValues} from 'redux-form'
import styles from './SupplierForm.css'
import SettingField from 'components/Fields/ReduxForm/SettingField'
import PhoneNumberField from 'components/Fields/ReduxForm/PhoneNumberField'
import {connect} from 'react-redux'
import LabelSection from 'components/sections/LabelSection'
import {askDeleteSupplier, onClickCancel} from 'actions/inventory/supplier'
import validator from 'validator'

const validate = (values) => {
  const NOT_BLANK_ERROR = 'This field is required'
  const errors = {}
  if (!values.name) {
    errors.name = NOT_BLANK_ERROR
  } else if (!validator.isLength(values.name, {max: 100})) {
    errors.name = 'Name too long'
  }

  if (!values.phone) {
    errors.phone = NOT_BLANK_ERROR
  }

  if (!values.email) {
    errors.email = NOT_BLANK_ERROR
  } else if (!validator.isEmail(values.email)) {
    errors.email = 'Enter a valid email address'
  }

  if (!values.address) {
    errors.address = NOT_BLANK_ERROR
  }

  if (!values.city) {
    errors.city = NOT_BLANK_ERROR
  }

  if (!values.state) {
    errors.state = NOT_BLANK_ERROR
  }

  if (!values.postal_code) {
    errors.postal_code = NOT_BLANK_ERROR
  } else if (!validator.isLength(values.postal_code, {min: 5, max: 5}) || !validator.isNumeric(values.postal_code)) {
    errors.postal_code = 'Please enter a valid format'
  }

  return errors
}

class SupplierForm extends React.Component {
  render () {
    const {supplierForm, isSubmittingForm} = this.props
    return (<form className={styles.wrapper}>
      <div className={`${styles['field-wrapper']} supplier-field-wrapper`}>
        <LabelSection title='supplier details' />
        <div className='row'>
          <Field
            component='input'
            type='hidden'
            name='id'
            />
          <div className='col-sm-12 form-group'>
            <Field
              component={SettingField}
              name='name'
              className='form-control'
              placeholder='Supplier Name'
              />
          </div>
          <div className='col-md-6 form-group'>
            <Field
              component={PhoneNumberField}
              name='phone'
              type='tel'
              placeholder='812'
            />
          </div>
          <div className='col-md-6 form-group'>
            <Field
              component={SettingField}
              name='email'
              className='form-control'
              placeholder='Supplier Email'
              />
          </div>
          <div className='col-md-12'>
            <LabelSection title='    ' />
          </div>
          <div className='col-md-12 form-group'>
            <Field
              component={SettingField}
              name='address'
              className='form-control'
              placeholder='Supplier Address'
              />
          </div>
          <div className='col-md-4 form-group'>
            <Field
              component={SettingField}
              name='city'
              className='form-control'
              placeholder='City'
              />
          </div>
          <div className='col-md-4 form-group'>
            <Field
              component={SettingField}
              name='state'
              className='form-control'
              placeholder='State'
              />
          </div>
          <div className='col-md-4 form-group'>
            <Field
              component={SettingField}
              name='postal_code'
              className='form-control'
              placeholder='Zip'
              positiveNumberOnly
              maxFractionDigits={0}
              maxLength={5}
              />
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        {supplierForm && supplierForm.id && <span className='pull-left'>
          <button className='btn btn-danger' onClick={this._onClickDelete} type='button' disabled={isSubmittingForm}>
            <i className='fa fa-trash' />
          </button>
        </span>}
        <span className='pull-right'>
          <button className={`btn btn-default ${styles['btn-cancel']}`} onClick={this._onClickCancel} type='button' disabled={isSubmittingForm}>
            Cancel
          </button>
          <button className={`btn btn-primary ${styles['btn-save']}`} type='button' onClick={this.props.handleSubmit} disabled={isSubmittingForm}>
            Save
          </button>
        </span>
      </div>
    </form>)
  }

  _onClickCancel = (e) => {
    this.props.dispatch(onClickCancel())
    e.preventDefault()
    e.stopPropagation()
  }

  _onClickDelete = (e) => {
    const {dispatch, supplierDetail} = this.props
    dispatch(askDeleteSupplier(supplierDetail))
    e.preventDefault()
    e.stopPropagation()
  }
}

function mapStateToProps (state) {
  const {supplierDetail, isSubmittingForm} = state.inventory.supplier
  return {
    supplierDetail,
    supplierForm: getFormValues('supplier')(state),
    isSubmittingForm
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

const mapForm = {
  form: 'supplier',
  touchOnChange: true,
  validate
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(mapForm)(SupplierForm))



// WEBPACK FOOTER //
// ./app/pages/Inventory/Supplier/SupplierDetail/SupplierForm/SupplierForm.js